import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Breadcrumb, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  addUser,
  dropdownSubadmin,
  getSubadminList,
  postFinancial,
} from "../../../store/actions";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useRef } from "react";
import Loading from "../../../Common/extra/loading";
import PhoneInput from "react-phone-input-2";
import { MenuItem, Select } from "@material-ui/core";
import { isEmail, isEmpty, isMobilePhone } from "validator";
import moment from "moment";

const MarryStatus = [
  {
    name: "Single",
    id: "Single",
  },
  {
    name: "Married filing Jointly",
    id: "Married filing Jointly",
  },
  {
    name: "Married filing seperate",
    id: "Married filing seperate",
  },
];

const EmpStatus = [
  {
    name: "W2",
    id: "W2",
  },
  {
    name: "Self-Employed",
    id: "Self-Employed",
  },
  {
    name: "1099",
    id: "1099",
  },
  {
    name: "Retired",
    id: "Retired",
  },
  {
    name: "Disabled",
    id: "Disabled",
  },
];

const YesNo = [
  {
    name: "Yes",
    id: "yes",
  },
  {
    name: "No",
    id: "no",
  },
];

const Tax = [
  {
    name: "Federal",
    id: "Federal",
  },
  {
    name: "State",
    id: "State",
  },
  {
    name: "IRS or State",
    id: "IRS or State",
  },
];

const Zones = [
  {
    name: "EST",
    id: "EST",
  },
  {
    name: "CST",
    id: "CST",
  },
  {
    name: "MST",
    id: "MST",
  },
  {
    name: "MDT",
    id: "MDT",
  },
  {
    name: "PST",
    id: "PST",
  },
  {
    name: "Alaska",
    id: "Alaska",
  },
  {
    name: "Hawai",
    id: "Hawai",
  },
];

var UsStates = [
  { code: "AL", name: "Alabama" },
  { code: "AK", name: "Alaska" },
  { code: "AZ", name: "Arizona" },
  { code: "AR", name: "Arkansas" },
  { code: "CA", name: "California" },
  { code: "CO", name: "Colorado" },
  { code: "CT", name: "Connecticut" },
  { code: "DE", name: "Delaware" },
  { code: "FL", name: "Florida" },
  { code: "GA", name: "Georgia" },
  { code: "HI", name: "Hawaii" },
  { code: "ID", name: "Idaho" },
  { code: "IL", name: "Illinois" },
  { code: "IN", name: "Indiana" },
  { code: "IA", name: "Iowa" },
  { code: "KS", name: "Kansas" },
  { code: "KY", name: "Kentucky" },
  { code: "LA", name: "Louisiana" },
  { code: "ME", name: "Maine" },
  { code: "MD", name: "Maryland" },
  { code: "MA", name: "Massachusetts" },
  { code: "MI", name: "Michigan" },
  { code: "MN", name: "Minnesota" },
  { code: "MS", name: "Mississippi" },
  { code: "MO", name: "Missouri" },
  { code: "MT", name: "Montana" },
  { code: "NE", name: "Nebraska" },
  { code: "NV", name: "Nevada" },
  { code: "NH", name: "New Hampshire" },
  { code: "NJ", name: "New Jersey" },
  { code: "NM", name: "New Mexico" },
  { code: "NY", name: "New York" },
  { code: "NC", name: "North Carolina" },
  { code: "ND", name: "North Dakota" },
  { code: "OH", name: "Ohio" },
  { code: "OK", name: "Oklahoma" },
  { code: "OR", name: "Oregon" },
  { code: "PA", name: "Pennsylvania" },
  { code: "RI", name: "Rhode Island" },
  { code: "SC", name: "South Carolina" },
  { code: "SD", name: "South Dakota" },
  { code: "TN", name: "Tennessee" },
  { code: "TX", name: "Texas" },
  { code: "UT", name: "Utah" },
  { code: "VT", name: "Vermont" },
  { code: "VA", name: "Virginia" },
  { code: "WA", name: "Washington" },
  { code: "WV", name: "West Virginia" },
  { code: "WI", name: "Wisconsin" },
  { code: "WY", name: "Wyoming" },
];

const AddCallerClientIndex = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const UserList = useSelector((s) => s?.Signatures?.subadmins?.data);
  const id = location.pathname.split("/")[3];
  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_phone: "",
    // date_of_birth: "",
    address: "",
    Address_two: "",
    // social_security_no: "",
    marital_status: "",
    spouse_name: "",
    spouse_mobile: "",
    spouse_email: "",
    // spouse_date_of_birth: "",
    // spouse_social_security_no: "",
    employment: "",
    tax: "",
    tax_lien: "",
    letter_from_state: "",
    letter_date: "",
    tax_returns: "",
    payment_plan: "",
    health_challenges: "",
    still_health: "",
    subadmins: [],
    note: "",
    date_and_time: "",
    timezone: "",
    City: "",
    State: "",
    Zip: "",
  });
  const [personalInfo, setPersonalInfo] = useState({
    full_name: "",
    marital_status: "",
    address: "",
    home_phone: "",
    cell_phone: "",
    work_phone: "",
    email: "",
    fax: "",
    social_security_no: "",
    date_of_birth: "",
    name: "",
    age: "",
    relationship: "",
  });
  const [legalInfo, setLegalInfo] = useState({
    full_name: "",
    address: "",
    cell_phone: "",
    email: "",
  });

  const [bankruptcyInfo, setBankruptcyInfo] = useState({
    bank_name: "",
    account_number: "",
    amount: "",
    cell_phone: "",
    email: "",
    date_of_birth: "",
  });
  const [employmentInfo, setEmploymentInfo] = useState({
    employer: "",
    length_of_job: "",
    employer_address: "",
    occupation: "",
    pay_period: "",

    spouse_employer: "",
    spouse_length_of_job: "",
    spouse_employer_address: "",
    spouse_occupation: "",
    spouse_pay_period: "",
  });
  const [otherFinanceInfo, setOtherFinanceInfo] = useState({
    are_you_currently_a_party_to_law_suit: "",
    plaintiff_defendent: "",
    location_of_filing: "",
    case_no: "",
    subject_of_suit: "",
    have_you_ever_filed_for_bankcrupty_protection: "",
    date_of_filing: "",
    date_of_discharge: "",
    petition_no: "",
    location: "",
    increase_decrease_in_income: "",
    beneficiary_to_any_trust_estate_life_insurance: "",
  });
  const [personalAssets, setPersonalAssets] = useState({
    cash_on_hand: "",

    personal_fullname: "",
    personal_address_of_bank: "",
    personal_account_type: "",
    personal_account_number: "",
    personal_account_balance: "",

    additional_fullname: "",
    additional_address_of_bank: "",
    additional_account_type: "",
    additional_account_number: "",
    additional_account_balance: "",

    investment_type: "",
    investment_fullname: "",
    investment_address_of_institution: "",
    investment_account_number: "",
    investment_account_balance: "",

    whole_life_insurance: "",

    credit_fullname: "",
    credit_address_of_bank: "",
    credit_account_type: "",
    credit_account_number: "",
    credit_account_balance: "",
  });
  const [realPropertyOwned, setRealPropertyOwned] = useState({
    property_description: "",
    location: "",
    current_fair_market_value: "",
    loan_balance: "",
    amount_of_monthly_payment: "",
    amount_of_your_equity: "",
    name_of_lender: "",
    address: "",
    account_no: "",
  });
  const [vehicles, setVehicles] = useState({
    year: "",
    make: "",
    model: "",
    mileage: "",
    purchase_lease_date: "",
    cutrrent_market_value: "",
    amount_owned: "",
    monthly_payment: "",
    name: "",
    address: "",
    phone_of_lender_lessor: "",

    another_year: "",
    another_make: "",
    another_model: "",
    another_mileage: "",
    another_purchase_lease_date: "",
    another_cutrrent_market_value: "",
    another_amount_owned: "",
    another_monthly_payment: "",
    another_name: "",
    another_address: "",
    another_phone_of_lender_lessor: "",
  });
  const [assets, setAssets] = useState({
    furniture_location: "",
    furniture_value: "",
    furniture_loanbalance: "",

    personal_location: "",
    personal_value: "",
    personal_loanbalance: "",

    artwork_location: "",
    artwork_value: "",
    artwork_loanbalance: "",

    jewellery_location: "",
    jewellery_value: "",
    jewellery_loanbalance: "",

    collection_location: "",
    collection_value: "",
    collection_loanbalance: "",

    guns_location: "",
    guns_value: "",
    guns_loanbalance: "",

    coins_location: "",
    coins_value: "",
    coins_loanbalance: "",

    antiques_location: "",
    antiques_value: "",
    antiques_loanbalance: "",
  });
  const [incomeExpenseState, setIncomeExpenseState] = useState({
    gross_you: "",
    gross_spouse_partner: "",

    rent_you: "",
    rent_spouse_partner: "",

    other_you: "",
    other_spouse_partner: "",

    child_you: "",
    child_spouse_partner: "",

    soc_you: "",
    soc_spouse_partner: "",

    pension_you: "",
    pension_spouse_partner: "",

    misc_you: "",
    misc_spouse_partner: "",

    primary_home_mortgage: "",
    primary_home_tax_ins: "",
    any_other_mortgage: "",
    any_other_property_tax_ins: "",
    credit_card_payments_total: "",
    any_other_revolving_debt: "",
    installment_loan_payments: "",
    dependent_child_care: "",

    personal_loans: "",
    income_tax_from_paycheck: "",
    fourZeroOneKLoans: "",
    child_support: "",
    alimony: "",
    irs_liens: "",
    tuition: "",

    student_loans: "",
    gas: "",
    electric: "",
    water: "",
    trash_sewer: "",
    telephone: "",
    cell_phone: "",
    internet: "",
    cable_satellite: "",
    vehicle_insurance: "",
    maintenance: "",
    food: "",
    transportation: "",
    gardening_landscaping: "",
    housecleaning: "",
    other: "",

    insurance_medical_amount: "",
    insurance_medical_paycheck: "",

    insurance_dental_amount: "",
    insurance_dental_paycheck: "",

    insurance_life_amount: "",
    insurance_life_paycheck: "",

    insurance_vision_amount: "",
    insurance_vision_paycheck: "",

    insurance_disability_amount: "",
    insurance_disability_paycheck: "",

    insurance_surrender_amount: "",
    insurance_surrender_paycheck: "",
  });

  useEffect(() => {
    dispatch(dropdownSubadmin({ searchBy: "role", search: "subadmin" }));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setData((pre) => ({ ...pre, [name]: value }));
  };

  const handleMultipleChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => ({ ...pre, [name]: value }));
  };

  useEffect(() => {
    if (data) {
      setPersonalInfo((pre) => ({
        ...pre,
        full_name: data.first_name + " " + data.last_name,
        email: data.email,
        address: data.address,
        Address_two: data.Address_two,
        cell_phone: data.mobile_phone ? "+" + data.mobile_phone : "",
      }));
    }
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    let body = {
      FirstName: data.first_name,
      LastName: data.last_name,
      Email: data.email,
      Address: data.address,
      Address_two: data.Address_two,
      CellPhone: data.mobile_phone ? "+" + data.mobile_phone : "",
      Marital_Status: data.marital_status,
      subadmins: data.subadmins ? JSON.stringify(data.subadmins) : "[]",
      TaxProblem: [],
      pick_your_states: [],
      timezone: data.timezone,
      State: data.State,
      City: data.City,
      Zip: data.Zip,
    };

    let financeBody = {
      personal_information: personalInfo,
      bankruptcy_field: bankruptcyInfo,
      legal_fields: legalInfo,
      employment_information: employmentInfo,
      other_finanical_information: otherFinanceInfo,
      personal_assets: personalAssets,
      real_property_owned: realPropertyOwned,
      vehicles: vehicles,
      another_vehicle_description: {},
      assets: assets,
      income: incomeExpenseState,
      expenses: {},
      expenses_insurance: {},
    };

    const callBack = (res) => {
      setLoading(false);
      if (res.data) {
        dispatch(
          postFinancial(
            { user_id: Number(res?.data?.id), ...financeBody },
            res?.data?.id
          )
        );
        toast.success("Client Added Successfully");
        setTimeout(() => {
          navigate("/customers");
        }, 500);
      } else {
        toast.error(res.error);
      }
    };

    dispatch(addUser(body, callBack));
  };

  const handlePhone = (name, phoneNumber, dialCode, validate) => {
    if (!phoneNumber || !dialCode) return false;
    switch (name) {
      case "mobile_number":
        if (!validate) {
          Error[name] = "Invalid Number";
        } else {
          Error[name] = "";
        }
        break;

      default:
        break;
    }
    setData((pre) => ({
      ...pre,
      [name]: phoneNumber,
    }));
  };
  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href="/caller-clients">
                    Client
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>Add</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white card-box px-4 py-3 rounded">
                <Form>
                  <Row>
                    <Col lg="12" className="my-2">
                      <h6>Basic Information</h6>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        First Name
                      </label>
                      <input
                        type="text"
                        name="first_name"
                        value={data?.name}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Last Name
                      </label>
                      <input
                        type="text"
                        name="last_name"
                        value={data.last_name}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={data?.email}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Mobile Phone
                      </label>
                      <PhoneInput
                        country={"us"}
                        value={data.mobile_phone}
                        placeholder="Mobile Phone"
                        onChange={(data, country) => {
                          let validateWithLength = country.format?.split(".");
                          validateWithLength = validateWithLength?.length - 1;
                          if (validateWithLength == data.length) {
                            handlePhone(
                              "mobile_phone",
                              data,
                              country.dialCode,
                              true
                            );
                          } else {
                            handlePhone(
                              "mobile_phone",
                              data,
                              country.dialCode,
                              false
                            );
                          }
                        }}
                      />
                    </Col>
                    {/* <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Date of Birth
                      </label>
                      <input
                        type="date"
                        name="date_of_birth"
                        value={data?.date_of_birth}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                    </Col> */}
                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Address
                      </label>
                      <input
                        type="text"
                        name="address"
                        value={data?.address}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Address Line 2
                      </label>
                      <input
                        type="text"
                        name="Address_two"
                        value={data?.Address_two}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        City
                      </label>
                      <input
                        type="text"
                        name="City"
                        value={data?.City}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                    </Col>
                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        State
                      </label>
                      <Select
                        className="demo-simple-select-label mt-2"
                        id="demo-simple-select"
                        name="State"
                        value={data.State}
                        onChange={handleChange}
                        MenuProps={UsStates}
                      >
                        {UsStates &&
                          UsStates.length > 0 &&
                          UsStates.map((item, idx) => {
                            return (
                              <MenuItem key={item.code} value={item.code}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Zip
                      </label>
                      <input
                        type="number"
                        name="Zip"
                        value={data?.Zip}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                    </Col>
                    {/* <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        SSN (Social Security no.)
                      </label>
                      <input
                        type="number"
                        name="social_security_no"
                        value={data?.social_security_no}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                    </Col> */}
                    <Col lg="12" className="my-2">
                      <h6>Marital Information</h6>
                    </Col>

                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        How did you file your taxes?
                      </label>
                      <Select
                        className="demo-simple-select-label mt-2"
                        id="demo-simple-select"
                        name="marital_status"
                        value={data.marital_status}
                        onChange={handleChange}
                        MenuProps={MarryStatus}
                      >
                        {MarryStatus &&
                          MarryStatus.length > 0 &&
                          MarryStatus.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </Col>
                    {data.marital_status == "Married filing Jointly" && (
                      <>
                        <Col lg="6" className="my-2">
                          <label htmlFor="" className="form-label2 m-0">
                            Name of spouse
                          </label>
                          <input
                            type="text"
                            name="spouse_name"
                            value={data?.spouse_name}
                            onChange={handleChange}
                            placeholder=""
                            className="form-control"
                          />
                        </Col>
                        <Col lg="6" className="my-2">
                          <label htmlFor="" className="form-label2 m-0">
                            Mobile Phone
                          </label>
                          <PhoneInput
                            country={"us"}
                            value={data.spouse_mobile}
                            placeholder="Mobile Phone"
                            onChange={(data, country) => {
                              let validateWithLength =
                                country.format?.split(".");
                              validateWithLength =
                                validateWithLength?.length - 1;
                              if (validateWithLength == data.length) {
                                handlePhone(
                                  "spouse_mobile",
                                  data,
                                  country.dialCode,
                                  true
                                );
                              } else {
                                handlePhone(
                                  "spouse_mobile",
                                  data,
                                  country.dialCode,
                                  false
                                );
                              }
                            }}
                          />
                        </Col>
                        <Col lg="6" className="my-2">
                          <label htmlFor="" className="form-label2 m-0">
                            Email
                          </label>
                          <input
                            type="email"
                            name="spouse_email"
                            value={data?.spouse_email}
                            onChange={handleChange}
                            placeholder=""
                            className="form-control"
                          />
                        </Col>

                        {/* <Col lg="6" className="my-2">
                          <label htmlFor="" className="form-label2 m-0">
                            Date of birth
                          </label>
                          <input
                            type="date"
                            name="spouse_date_of_birth"
                            value={data?.spouse_date_of_birth}
                            onChange={handleChange}
                            placeholder=""
                            className="form-control"
                          />
                        </Col> */}
                        {/* <Col lg="6" className="my-2">
                          <label htmlFor="" className="form-label2 m-0">
                            SSN (Social Security no.)
                          </label>
                          <input
                            type="number"
                            name="spouse_social_security_no"
                            value={data?.spouse_social_security_no}
                            onChange={handleChange}
                            placeholder=""
                            className="form-control"
                          />
                        </Col> */}
                      </>
                    )}
                    <Col lg="12" className="my-2">
                      <h6>Employment/Work Info</h6>
                    </Col>

                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Employment/Work
                      </label>
                      <Select
                        className="demo-simple-select-label mt-2"
                        id="demo-simple-select"
                        name="employment"
                        value={data.employment}
                        onChange={handleChange}
                        MenuProps={EmpStatus}
                      >
                        {EmpStatus &&
                          EmpStatus.length > 0 &&
                          EmpStatus.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </Col>

                    <Col lg="12" className="my-2">
                      <h6>Tax Info</h6>
                    </Col>

                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Tax
                      </label>
                      <Select
                        className="demo-simple-select-label mt-2"
                        id="demo-simple-select"
                        name="tax"
                        value={data.tax}
                        onChange={handleChange}
                        MenuProps={Tax}
                      >
                        {Tax &&
                          Tax.length > 0 &&
                          Tax.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </Col>

                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Do you have a tax lien
                      </label>
                      <Select
                        className="demo-simple-select-label mt-2"
                        id="demo-simple-select"
                        name="tax_lien"
                        value={data.tax_lien}
                        onChange={handleChange}
                        MenuProps={YesNo}
                      >
                        {YesNo &&
                          YesNo.length > 0 &&
                          YesNo.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </Col>

                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Have you received a letter from the IRS or the State?
                      </label>
                      <Select
                        className="demo-simple-select-label mt-2"
                        id="demo-simple-select"
                        name="letter_from_state"
                        value={data.letter_from_state}
                        onChange={handleChange}
                        MenuProps={YesNo}
                      >
                        {YesNo &&
                          YesNo.length > 0 &&
                          YesNo.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </Col>

                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        If yes, when did you receive the letter?
                      </label>
                      <input
                        type="date"
                        name="letter_date"
                        value={data?.letter_date}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                    </Col>

                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Do you have any Non-Filed Tax Returns?
                      </label>
                      <Select
                        className="demo-simple-select-label mt-2"
                        id="demo-simple-select"
                        name="tax_returns"
                        value={data.tax_returns}
                        onChange={handleChange}
                        MenuProps={YesNo}
                      >
                        {YesNo &&
                          YesNo.length > 0 &&
                          YesNo.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </Col>

                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Are you on a payment plan for your taxes?
                      </label>
                      <Select
                        className="demo-simple-select-label mt-2"
                        id="demo-simple-select"
                        name="payment_plan"
                        value={data.payment_plan}
                        onChange={handleChange}
                        MenuProps={YesNo}
                      >
                        {YesNo &&
                          YesNo.length > 0 &&
                          YesNo.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </Col>

                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Have you had any health or medical challenges since your
                        tax issues?
                      </label>
                      <Select
                        className="demo-simple-select-label mt-2"
                        id="demo-simple-select"
                        name="health_challenges"
                        value={data.health_challenges}
                        onChange={handleChange}
                        MenuProps={YesNo}
                      >
                        {YesNo &&
                          YesNo.length > 0 &&
                          YesNo.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </Col>

                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        If Yes, do you still have any health challenges that are
                        ongoing?
                      </label>
                      <Select
                        className="demo-simple-select-label mt-2"
                        id="demo-simple-select"
                        name="still_health"
                        value={data.still_health}
                        onChange={handleChange}
                        MenuProps={YesNo}
                      >
                        {YesNo &&
                          YesNo.length > 0 &&
                          YesNo.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </Col>
                    <Col lg="12" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Assign Client to the Team
                      </label>
                      <Select
                        className="demo-simple-select-label mt-2"
                        id="demo-simple-select"
                        multiple
                        name="subadmins"
                        value={data.subadmins || []}
                        onChange={handleMultipleChange}
                        MenuProps={UserList || []}
                      >
                        {UserList &&
                          UserList.length > 0 &&
                          UserList.map((item, idx) => {
                            console.log(
                              item.soft_delete,
                              item.name,
                              "item soft delete"
                            );
                            return (
                              <>
                                {item.soft_delete &&
                                  item.soft_delete == "1" && (
                                    <MenuItem key={item.id} value={item.id}>
                                      {item.name + " " + item.last_name}
                                    </MenuItem>
                                  )}
                              </>
                            );
                          })}
                      </Select>
                    </Col>
                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Select Timezone
                      </label>
                      <Select
                        className="demo-simple-select-label mt-2"
                        id="demo-simple-select"
                        name="timezone"
                        value={data.timezone}
                        onChange={handleChange}
                        MenuProps={Zones}
                      >
                        {Zones &&
                          Zones.length > 0 &&
                          Zones.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                      {/* <span className="note error_note py-2 m-0 text-danger">
                        {errors.timezone}
                      </span> */}
                    </Col>
                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Date and Time to Call
                      </label>
                      <input
                        type="datetime-local"
                        name="date_and_time"
                        value={data?.date_and_time}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                    </Col>
                    <Col lg="12" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Note
                      </label>
                      <textarea
                        name="note"
                        value={data?.note}
                        onChange={handleChange}
                        placeholder=""
                        rows={6}
                        className="form-control"
                      />
                    </Col>
                    <Col lg="12" className="my-2">
                      <div className="pt-4 btn-wrp d-flex algign-items-center">
                        <Button
                          onClick={handleSubmit}
                          className="d-flex align-items-center justify-content-center me-2"
                        >
                          Submit
                        </Button>
                        <Link
                          to={`/caller-clients`}
                          className="d-flex btn-2 border align-items-center justify-content-center me-2"
                        >
                          <span className="me-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="9"
                              viewBox="0 0 12 9"
                              fill="none"
                            >
                              <path
                                d="M2.8725 3.75L5.5575 1.0575L4.5 0L0 4.5L4.5 9L5.5575 7.9425L2.8725 5.25H12V3.75H2.8725Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          Back
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default AddCallerClientIndex;
